module.exports = __webpack_public_path__ + "videos/norris-hello.650ac01.webm";